import Vue from "vue";
import VueRouter from "vue-router";
import cloudManage from "@/views/cloudInfra/cloudManage.vue"
import cloudMonitor from "@/views/cloudInfra/cloudMonitor.vue"
import awcmp from "@/views/cloudInfra/awcmp.vue"
import containerManage from "@/views/cloudInfra/containerManage.vue"
import awstack from "@/views/cloudInfra/awstack.vue"
import cloudService from "@/views/cloudService/cloudService.vue"
import aiStack from "@/views/aiInfra/aiStack.vue"
import model from "@/views/aiInfra/model.vue"
import aibox from "@/views/iot/aiBox.vue"
import fiveg from "@/views/iot/fiveG.vue"
import iot from "@/views/iot/iot.vue"
import lab from "@/views/edu/ailab.vue"
import aiep from "@/views/edu/aiep.vue"
import awc from "@/views/edu/awc.vue"
import cpu from "@/views/edu/cpu.vue"
import usb from "@/views/edu/usb.vue"
import hdw from "@/views/edu/hardware.vue"
import svm from "@/views/industry/svm.vue"
import privateClouds from "@/views/solution/privateClouds.vue"
import yzxAi from "@/views/solution/yzxAi.vue"
import match from "@/views/solution/match.vue"
import subject from "@/views/solution/subject.vue"
import icCenter from "@/views/solution/icCenter.vue"
import iotSolution from "@/views/solution/iotSolution.vue"
import cdd from '@/views/cdd/index.vue'
import cases from '@/views/cases/index.vue'
import caseDetail from '@/views/cases/detail.vue'
import document from '@/views/preSalesSupport/document.vue'
import consult from '@/views/preSalesSupport/consult.vue'
import company from '@/views/company/index.vue'
import desc from '@/views/company/about.vue'
import contact from '@/views/company/contact.vue'
import join from '@/views/company/join.vue'
import cooperate from '@/views/company/cooperate.vue'
import news from '@/views/news/index.vue'
import competition from '@/views/news/competition.vue'
import enterprise from '@/views/news/enterprise.vue'
import enterpriseDetail from '@/views/news/enterDetail.vue'
Vue.use(VueRouter);
const routes = [
    {
        path: '/',
        redirect: '/awcloud'
    },
    {
        path: '/awcloud',
        name: 'awcloud',
        component: cloudManage,
        title: 'AWCloud云计算管理平台',
    },
    {
        path: '/monitor',
        name: 'cloudMonitor',
        component: cloudMonitor,
        title: 'AWCloud监控云',
    },
    {
        path: '/awcmp',
        name: 'awcmp',
        component: awcmp,
        title: 'AWCMP多云管理平台',
    },
    {
        path: '/awcdp',
        name: 'containerManage',
        component: containerManage,
        title: 'AWCloud容器管理平台',
    },
    {
        path: '/awstack',
        name: 'awstack',
        component: awstack,
        title: 'AWSTACK超融合一体机',
    },
    {
        path: '/cloudservice',
        name: 'cloudService',
        component: cloudService,
        title: '云服务',
    },
    {
        path: '/aiStack',
        name: 'aiStack',
        component: aiStack,
        title: 'AIStack人工智能管理平台',
    },
    {
        path: '/model',
        name: 'model',
        component: model,
        title: 'AI大模型训推一体机',
    },
    {
        path: '/aibox',
        name: 'aibox',
        component: aibox,
        title: '智能边缘盒子awc_aiBox',
    },
    {
        path: '/5g',
        name: 'fiveg',
        component: fiveg,
        title: '5G边缘网关',
    },
    {
        path: '/iot',
        name: 'iot',
        component: iot,
        title: '物联网管理平台',
    },

    {
        path: '/ailab',
        name: 'lab',
        component: lab,
        title: 'AILab实验管理平台',
    },
    {
        path: '/aiep',
        name: 'aiep',
        component: aiep,
        title: 'AIEP人工智能边缘实验室',
    },
    {
        path: '/awcc4fpga',
        name: 'awc',
        component: awc,
        title: 'AWC_C4 FPGA开发套件',
    },
    {
        path: '/cpu',
        name: 'cpu',
        component: cpu,
        title: '开放式CPU创新实验平台',
    },
    {
        path: '/usb',
        name: 'usb',
        component: usb,
        title: 'USB BlasterII下载线',
    },
    {
        path: '/hdw',
        name: 'hdw',
        component: hdw,
        title: '智能实训硬件',
    },
    {
        path: '/svm',
        name: 'svm',
        component: svm,
        title: 'SVM智能表检系统',
    },
    {
        path: '/private_solutions',
        name: 'privateClouds',
        component: privateClouds,
        title: '私有云解决方案',
    },
    {
        path: '/yuzhixin',
        name: 'yzxAi',
        component: yzxAi,
        title: '育智芯人工智能实验室解决方案',
    },
    {
        path: '/match_operations',
        name: 'match',
        component: match,
        title: '赛事运营',
    },
    {
        path: '/research',
        name: 'subject',
        component: subject,
        title: '科研课题',
    },
    {
        path: '/ic_center',
        name: 'icCenter',
        component: icCenter,
        title: '智算中心解决方案',
    },
    {
        path: '/iot_solution',
        name: 'iotSolution',
        component: iotSolution,
        title: '物联网+解决方案',
    },
    {
        path: '/custom_development',
        name: 'cdd',
        component: cdd,
        title: '定制开发',
    },
    {
        path: '/cases',
        name: 'cases',
        component: cases,
        title: '案例',
    },
    {
        path: '/case_detail',
        name: 'caseDetail',
        component: caseDetail,
        title: '案例详情',
    },
    {
        path: '/document',
        name: 'document',
        component: document,
        title: '产品文档',
    },
    {
        path: '/consult',
        name: 'consult',
        component: consult,
        title: '业务咨询',
    },
    {
        path: '/about',
        name: 'company',
        component: company,
        redirect: '/about/desc', // 默认重定向到 about 子路由
        children: [
            {
                path: 'desc',
                name: 'desc',
                component: desc,
                title: '企业简介',
            },
            {
                path: 'contact',
                name: 'contact',
                component: contact,
                title: '联系我们'
            },
            {
                path: 'join',
                name: 'join',
                component: join,
                title: '加入我们'
            }
        ]
    },
    {
        path: '/cooperate',
        name: 'cooperate',
        component: cooperate,
        title: '合作伙伴',
    },
    {
        path: '/news',
        name: 'news',
        component: news,
        redirect: '/news/enterprise', // 默认重定向到 about 子路由
        children: [
            {
                path: 'enterprise',
                name: 'enterprise',
                component: enterprise,
                title: '企业新闻',
            },
            {
                path: 'enterprise/detail',
                name: 'enterpriseDetail',
                component: enterpriseDetail,
                title: '企业新闻',
            },
            {
                path: 'competition',
                name: 'competition',
                component: competition,
                title: '大赛'
            },
        ]
    },
    
]

const router = new VueRouter({
    mode: 'history',
    routes,
});

export default router;
